import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Search, Users, User, Bell, Shield } from 'lucide-react';
import UnreadBadge from './UnreadBadge';
import { useUser } from '../../contexts/UserContext';
import { canSee } from '../../lib/adminNav';

const navItems = [
  { id: 'feed', path: '/feed', icon: Home, label: 'Home' },
  { id: 'explore', path: '/explore', icon: Search, label: 'Explore' },
  { id: 'community', path: '/community', icon: Users, label: 'Tables' },
  // "Activity" not "Notifications": 13 chars wraps to two lines in a 5-across
  // row on a 320px iPhone SE, and it'd be the only label that does.
  { id: 'notifications', path: '/notifications', icon: Bell, label: 'Activity' },
  { id: 'profile', path: '/profile', icon: User, label: 'Profile' },
];

const BottomNav = ({ unreadCount = 0 }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { userData } = useUser();
  // A 6th tab for moderator and up only (AdminRoute's rule; staff don't have
  // /admin). Six short labels fit a 320px iPhone SE without wrapping:
  // buttons size to their labels (~264px total) inside 288px of row.
  const items = canSee(userData?.app_role, 'moderator')
    ? [...navItems, { id: 'admin', path: '/admin', icon: Shield, label: 'Admin' }]
    : navItems;

  return (
    <div
      className="fixed bottom-0 left-0 right-0"
      style={{
        zIndex: 10,
        backgroundColor: 'var(--nav-bg)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderTop: '1px solid var(--nav-border)',
      }}
    >
      <div className="max-w-2xl mx-auto px-4 pt-3 flex justify-around" style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0.75rem))' }}>
        {items.map(({ id, path, icon: Icon, label }) => {
          const isActive = pathname.startsWith(path);
          return (
            <button
              key={id}
              onClick={() => navigate(path)}
              className="relative flex flex-col items-center gap-1 transition-colors"
              style={{ color: isActive ? 'var(--brand-primary)' : 'var(--text-tertiary)' }}
            >
              {/* Badge anchors to the icon, not the icon+label box */}
              <span className="relative">
                <Icon size={24} />
                {id === 'notifications' && <UnreadBadge count={unreadCount} />}
              </span>
              <span className={`text-xs ${isActive ? 'font-medium' : ''}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
